<div
	[ngClass]="{ 'height-in-opportunity-page': inOpportunitiesPage }"
	fxLayout="row"
	fxLayoutGap="1rem"
	*ngIf="v1PricingLayout"
>
	<div fxFlex>
		<mat-card
			*ngIf="PRODUCT_PRICING"
			class="h-100 padding-0-5 pricingCard"
			id="currentRates"
		>
			<mat-card-title class="primary-text font-size-20" fxLayoutAlign="center center">
				Current Rates
			</mat-card-title>
			<mat-card-subtitle
				*ngIf="!priceNotFound && isCitySelectedInSearchTruckForm"
				class="primary-text m-b-0"
			>
				<div class="p-8" fxLayoutAlign="space-between center">
					<span>
						<span>Fuel/Gal: </span>
						<span *ngIf="!isLanePricingRequestInProgress; else skeletonLoader">
							<span *ngIf="lanePricing?.fuelCostPerMile; else loadingText">
								&nbsp;&nbsp;{{
									lanePricing.fuelCostPerMile | currency : 'USD' : 'symbol' : '1.2-2'
								}}
							</span>
						</span>
					</span>

					<span>
						Trip Miles:
						<span *ngIf="!isLanePricingRequestInProgress; else skeletonLoader">
							<span *ngIf="lanePricing?.laneMiles; else loadingText">
								&nbsp;&nbsp;{{ lanePricing?.laneMiles }}
							</span>
						</span>
					</span>
				</div>
			</mat-card-subtitle>

			<mat-card-content class="m-b-0 pricingCardContent">
				<div
					*ngIf="
						!priceNotFound && isCitySelectedInSearchTruckForm;
						else currentRatesErrorMsg
					"
				>
					<div
						class="p-8 primary-text font-size-13 p-b-0 p-r-0"
						fxLayout="row"
						fxLayoutAlign="{{
							accountSettings.CONFIDENCE_SCORE ? 'space-between start' : 'start start'
						}}"
						[ngClass]="{
							'p-t-0': !accountSettings.CONFIDENCE_SCORE,
							'p-t-0-5': accountSettings.CONFIDENCE_SCORE
						}"
					>
						<div
							class="font-size-16"
							[ngClass]="{ 'white_space_nowrap p-t-1': !accountSettings.CONFIDENCE_SCORE }"
							fxLayoutAlign="{{
								!accountSettings.CONFIDENCE_SCORE ? 'start center' : 'start start'
							}}"
						>
							<strong>All In: </strong>
						</div>
						<div
							fxLayout="column"
							fxLayoutAlign="{{
								accountSettings.CONFIDENCE_SCORE ? 'start center' : 'center center'
							}}"
							[ngClass]="{ 'full-width': !accountSettings.CONFIDENCE_SCORE }"
						>
							<div
								*ngIf="!isLanePricingRequestInProgress; else skeletonLoader"
								class="font-size-16"
								fxFlex
								fxLayoutAlign="center center"
								[ngClass]="{ 'font-size-2rem': !accountSettings.CONFIDENCE_SCORE }"
							>
								<strong *ngIf="lanePricing?.allInCost; else loadingText">{{
									lanePricing.allInCost | currency : 'USD' : 'symbol' : '1.0-0'
								}}</strong>
							</div>
							<div fxLayoutAlign="center">
								<span
									>({{ lanePricing?.allInCostLow | currency : 'USD' : 'symbol' : '1.0-0' }} -
									{{ lanePricing?.allInCostHigh | currency : 'USD' : 'symbol' : '1.0-0' }})</span
								>
							</div>
						</div>
						<div
							*ngIf="environment.CONFIDENCE_SCORE && accountSettings.CONFIDENCE_SCORE"
							class="primary-text font-size-13"
							fxLayout="row"
						>
							<div fxFlex="40"></div>
							<div
								*ngIf="!isLanePricingRequestInProgress; else skeletonLoader"
								fxFlex
								fxLayout="column"
								fxLayoutAlign="start start"
								class="font-size-13 cursor-pointer"
							>
								<div
									*ngIf="IS_NOT_NULL_OR_UNDEFINED(lanePricing?.confidenceScore); else loadingText"
								>
									<meter
										high="4"
										low="2"
										max="5"
										min="0"
										optimum="5"
										[value]="lanePricing.confidenceScore"
									></meter>
								</div>
								<p
									class="font-size-9 m-t-0"
									matTooltip="Confidence Score"
									matTooltipClass="custom-tooltip"
									fxLayout="row"
								>
									Confidence
									<mat-icon class="font-size-9 ml-2">info_outline</mat-icon>
								</p>
							</div>
						</div>
					</div>

					<div
						class="p-8 primary-text p-t-0 p-b-0"
						fxLayout="row"
						[ngClass]="{
							'm-t-1': !accountSettings.CONFIDENCE_SCORE,
							'm-t-0-5': accountSettings.CONFIDENCE_SCORE
						}"
					>
						<div class="font-size-16" fxFlex="40">
							<b>Per Mile: </b>
						</div>
						<div
							*ngIf="!isLanePricingRequestInProgress; else skeletonLoader"
							class="font-size-16 m-r-1"
							fxFlex
							fxLayoutAlign="end center"
						>
							<b *ngIf="lanePricing?.allInCost && lanePricing.laneMiles; else loadingText">
								{{
									lanePricing.allInCost / lanePricing.laneMiles
										| currency : 'USD' : 'symbol' : '1.2-2'
								}}
							</b>
						</div>
					</div>
					<div class="primary-text font-size-13 p-r-0" fxLayout="row">
						<div fxFlex="40"></div>
						<div
							*ngIf="!isLanePricingRequestInProgress; else skeletonLoader"
							fxFlex
							fxLayoutAlign="end center"
						>
							<span *ngIf="IS_NOT_NULL_OR_UNDEFINED(lanePricing); else loadingText">
								(
								<span *ngIf="lanePricing?.allInCostLow && lanePricing?.laneMiles">
									{{
										lanePricing.allInCostLow / lanePricing.laneMiles
											| currency : 'USD' : 'symbol' : '1.2-2'
									}}
								</span>
								-
								<span *ngIf="lanePricing?.allInCostHigh && lanePricing.laneMiles">
									{{
										lanePricing.allInCostHigh / lanePricing.laneMiles
											| currency : 'USD' : 'symbol' : '1.2-2'
									}}
								</span>
								)
							</span>
						</div>
					</div>
					<br />
				</div>

				<div
					*ngIf="
						utilService.isNullOrUndefined(lanePricing) &&
						priceNotFound &&
						isCitySelectedInSearchTruckForm
					"
				>
					<div class="p-8 primary-text font-size-13 p-t-0">
						There are not enough current transactions in this system to accurately forecast this
						lane. If you run this lane regularly, contributing your transactions to the system will
						help us giving you better pricing information.
					</div>
					<div class="p-8 primary-text font-size-13">
						To find out more email
						<a class="link" href="mailto:customercare@cargochief.com">
							customercare@cargochief.com
						</a>
					</div>
				</div>
			</mat-card-content>

			<mat-card-actions *ngIf="!priceNotFound" class="padding-0-5 rates-ard-action-margin p-t-0">
				<div
					*ngIf="IS_NOT_NULL_OR_UNDEFINED(lanePricing)"
					class="primary-text font-size-12"
					fxLayout="row"
				>
					<div class="mt-3" fxFlex="45">Is the rate accurate?</div>
					<div fxFlex>
						<mat-radio-button
							(click)="!rateFeedbackProvided && submitRateFeedback('spotOn')"
							class="font-size-12"
							color="primary"
						>
							Spot On
						</mat-radio-button>
					</div>
					<div fxFlex fxLayoutAlign="end center">
						<mat-radio-button
							(click)="!rateFeedbackProvided && submitRateFeedback('notAccurate')"
							class="font-size-12"
							color="primary"
						>
							No
						</mat-radio-button>
					</div>
				</div>
			</mat-card-actions>
		</mat-card>
	</div>

	<div fxFlex>
		<mat-card
			*ngIf="productsService.RECENT_TRANSACTIONS"
			class="h-100 padding-0-5 pricingCard"
			id="recentTransactions"
		>
			<mat-card-title class="primary-text font-size-20" fxLayoutAlign="center center">
				Recent Transactions
				<mat-icon
					[inline]="true"
					[mtxPopoverTriggerFor]="recentTransactionsPopover"
					class="primary-text w-inherit pl-2"
					matSuffix
					matTooltipClass="custom-tooltip"
					mtxPopoverTriggerOn="hover"
				>
					info
				</mat-icon>
			</mat-card-title>

			<mat-card-content
				*ngIf="!isRecentTransactionsRequestInProgress; else recentTransactionsSkeleton"
				class="m-b-0 pricingCardContent"
			>
				<div *ngIf="renderRecentTransactions(); else recentTransactionsLoader">
					<div class="p-8 primary-text font-size-13 font-size-7-vw headerPadding" fxLayout="row">
						<div fxFlex fxLayoutAlign="center center">
							<b><u>Pickup Date</u></b>
						</div>
						<div fxFlex fxLayoutAlign="center center">
							<b><u>Price</u></b>
						</div>
					</div>
					<div>
						<div
							*ngFor="let transaction of recentTransactions"
							[ngClass]="{ 'font-style-italics': transaction.forThisAccount }"
							class="p-8 primary-text font-size-13 font-size-7-vw p-t-0 row-mt-3"
							fxLayout="row"
						>
							<div fxFlex fxLayoutAlign="center center">
								{{ transaction.pickupDate | date : 'MM/dd/yyyy' }}
							</div>
							<div fxFlex fxLayoutAlign="center center">
								{{ transaction.allInCost / 100 | currency : 'USD' : 'symbol' : '1.0-0' }}
							</div>
						</div>
					</div>
				</div>
			</mat-card-content>

			<mat-card-actions
				*ngIf="
					showRecentTransactionsCard &&
					IS_NOT_NULL_OR_UNDEFINED(recentTransactions) &&
					recentTransactions.length > 0
				"
				class="padding-0-5"
				fxLayoutAlign="center center"
			>
				<span
					(click)="openRecentTransactionsDialog()"
					class="primary-text font-size-13 cursor-pointer"
				>
					<u>View Details</u>
				</span>
			</mat-card-actions>
		</mat-card>
	</div>
</div>
<div fxLayout="row" *ngIf="!v1PricingLayout && PRODUCT_PRICING">
	<mat-card class="full-width">
		<mat-card-content class="m-b-0">
			<!-- Without GreenScreens -->
			<div
				*ngIf="
					!priceNotFound &&
					isCitySelectedInSearchTruckForm &&
					!greenScreensEnabled
				"
			>
				<div
					class="full-width"
					fxLayoutGap="1rem"
					*ngIf="showCurrentRatesCard; else currentRatesNotAvailable"
				>
					<div fxFlex fxLayoutGap="1rem">
						<div fxLayoutAlign="start center">
							<div class="full-width" fxLayoutAlign="start center">
								<div class="font-size-16 font-weight-bold" fxLayoutAlign="start center">
									Per Mile:
								</div>
								<div
									*ngIf="!isLanePricingRequestInProgress; else skeletonLoader"
									class="font-size-16 m-l-1"
								>
									<b *ngIf="lanePricing?.allInCost && lanePricing.laneMiles; else loadingText">
										{{
											lanePricing.allInCost / lanePricing.laneMiles
												| currency : 'USD' : 'symbol' : '1.2-2'
										}}
									</b>
								</div>
							</div>
						</div>
						<div fxFlex>
							<div
								class="full-width"
								fxLayout="column"
								fxLayoutAlign="space-between start"
								*ngIf="lanePricing?.allInCostLow && lanePricing.allInCostHigh; else skeletonLoader"
							>
								<div fxFlex class="font-size-14 full-width" fxLayoutAlign="start start">
									Start:
									{{
										lanePricing.allInCostLow / lanePricing.laneMiles
											| currency : 'USD' : 'symbol' : '1.2-2'
									}}
								</div>
								<div fxFlex class="full-width" fxLayoutAlign="start center" #perMileEndContaier>
									<span class="font-size-14" #perMileEndTextContainer>
										&nbsp;End:
										{{
											lanePricing.allInCostHigh / lanePricing.laneMiles
												| currency : 'USD' : 'symbol' : '1.2-2'
										}}
									</span>
								</div>
							</div>
						</div>
					</div>
					<div fxFlex>
						<div fxLayout="row" fxLayoutGap="1rem">
							<div fxFlex #allInPriceContainer>
								<div fxLayout="row" fxLayoutAlign="space-between center">
									<div fxFlex class="font-size-16 font-weight-bold" fxLayoutAlign="start center">
										All In:
									</div>
									<div
										fxFlex
										*ngIf="!isLanePricingRequestInProgress; else skeletonLoader"
										class="font-size-2rem"
										fxLayoutAlign="center center"
									>
										<strong *ngIf="lanePricing?.allInCost; else loadingText">
											{{ lanePricing.allInCost | currency : 'USD' : 'symbol' : '1.0-0' }}
										</strong>
									</div>
								</div>
							</div>
							<div fxFlex="40">
								<div class="full-width p-l-2" fxLayout="column" fxLayoutAlign="space-between start">
									<div fxFlex class="full-width" fxLayoutAlign="start start">
										<span class="font-size-14">
											Start:&nbsp;
											<span
												*ngIf="
													lanePricing?.allInCostLow && lanePricing.allInCostHigh;
													else skeletonLoader
												"
											>
												{{ lanePricing?.allInCostLow | currency : 'USD' : 'symbol' : '1.0-0' }}
											</span>
										</span>
									</div>
									<div fxFlex class="full-width" fxLayoutAlign="start center">
										<span #allInPriceEnd class="font-size-14">
											&nbsp;End:&nbsp;
											<span
												*ngIf="
													lanePricing?.allInCostLow && lanePricing.allInCostHigh;
													else skeletonLoader
												"
											>
												{{ lanePricing?.allInCostHigh | currency : 'USD' : 'symbol' : '1.0-0' }}
											</span>
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div fxFlex fxLayoutAlign="end start">
						<div
							fxLayoutGap="1rem"
							fxLayoutAlign="space-between start"
							[ngStyle]="{
								'min-width': recentTransactionsLink?.nativeElement?.offsetWidth
									? 'calc(' + recentTransactionsLink.nativeElement.offsetWidth + 'px)'
									: 'inherit'
							}"
						>
							<div fxLayout="column">
								<div
									class="full-width confidence_meter_container"
									fxLayoutAlign="end start"
									*ngIf="lanePricing; else skeletonLoader"
								>
									<meter
										[style.width]="CONFIDENCE_METER_CONTAINER"
										high="4"
										low="2"
										max="5"
										min="0"
										optimum="5"
										[value]="lanePricing.confidenceScore"
									></meter>
								</div>
								<div
									class="full-width"
									fxLayoutAlign="end start"
									*ngIf="lanePricing; else skeletonLoader"
								>
									<span class="fn-size-13">Confidence:</span>
									<span>
										<mat-icon
											class="fn-size-13 confidence_meter_info_icon"
											fxLayoutAlign="center end"
											[mtxPopoverTriggerFor]="confidencePopover"
										>
											info_outline
										</mat-icon>
									</span>
								</div>
							</div>
							<div>
								<div class="full-width" fxLayout="column" fxLayoutAlign="space-between start">
									<div fxFlex class="font-size-16 full-width" fxLayoutAlign="end start">
										Min Paid:&nbsp;
										<span *ngIf="!isRecentTransactionsCountRequestInProgress; else skeletonLoader">
											{{
												recentTransactionsCount?.minAllInCost
													? (TO_DOLLARS(recentTransactionsCount.minAllInCost)
													  | currency : 'USD' : 'symbol' : '1.0-0')
													: 'N/A'
											}}
										</span>
									</div>
									<div fxFlex class="font-size-16 full-width" fxLayoutAlign="end center">
										Max Paid:&nbsp;
										<span *ngIf="!isRecentTransactionsCountRequestInProgress; else skeletonLoader">
											{{
												recentTransactionsCount?.maxAllInCost
													? (TO_DOLLARS(recentTransactionsCount.maxAllInCost)
													  | currency : 'USD' : 'symbol' : '1.0-0')
													: 'N/A'
											}}
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="full-width m-t-0-5" fxLayoutGap="1rem" *ngIf="showCurrentRatesCard">
					<div fxFlex fxLayoutGap="1rem" fxLayoutAlign="space-between center">
						<div fxFlex fxLayoutAlign="space-between center">
							<span>
								<span class="font-weight-bold">Fuel/Gal: </span>
								<span *ngIf="!isLanePricingRequestInProgress; else skeletonLoader">
									<span *ngIf="lanePricing?.fuelCostPerMile; else loadingText">
										&nbsp;&nbsp;{{
											lanePricing.fuelCostPerMile | currency : 'USD' : 'symbol' : '1.2-2'
										}}
									</span>
								</span>
							</span>

							<span
								class="font-weight-bold"
								[ngStyle]="{
									'margin-right':
										'calc(' +
										((perMileEndContaier?.nativeElement?.offsetWidth
											? perMileEndContaier.nativeElement.offsetWidth
											: 0) -
											(perMileEndTextContainer?.nativeElement?.offsetWidth
												? perMileEndTextContainer.nativeElement.offsetWidth
												: 0)) +
										'px)'
								}"
							>
								Trip Miles:
								<span *ngIf="!isLanePricingRequestInProgress; else skeletonLoader">
									<span *ngIf="lanePricing?.laneMiles; else loadingText" class="font-weight-normal">
										&nbsp;&nbsp;{{ lanePricing?.laneMiles }}
									</span>
								</span>
							</span>
						</div>
					</div>
					<div fxFlex fxLayoutAlign="space-between start">
						<div
							[ngStyle]="{
								'min-width':
									allInPriceContainer?.nativeElement?.offsetWidth &&
									allInPriceEnd?.nativeElement?.offsetWidth
										? 'calc(' +
										  (allInPriceContainer.nativeElement.offsetWidth +
												allInPriceEnd?.nativeElement?.offsetWidth +
												48) +
										  'px)'
										: 'inherit'
							}"
						>
							<div fxLayoutAlign="space-between center">
								<span fxLayoutAlign="start center"> Is the rate accurate? </span>
								<span *ngIf="lanePricing; else skeletonLoader">
									<mat-radio-button
										(click)="!rateFeedbackProvided && submitRateFeedback('spotOn')"
										class="font-size-12"
										color="primary"
									>
										Spot On
									</mat-radio-button>
								</span>
								<span *ngIf="lanePricing; else skeletonLoader">
									<mat-radio-button
										(click)="!rateFeedbackProvided && submitRateFeedback('notAccurate', 'high')"
										class="font-size-12"
										color="primary"
									>
										High
									</mat-radio-button>
								</span>
								<span *ngIf="lanePricing; else skeletonLoader">
									<mat-radio-button
										(click)="!rateFeedbackProvided && submitRateFeedback('notAccurate', 'low')"
										class="font-size-12"
										color="primary"
									>
										Low
									</mat-radio-button>
								</span>
							</div>
						</div>
					</div>
					<div fxFlex fxLayoutGap="1rem">
						<div
							fxFlex
							fxLayoutAlign="end center"
							*ngIf="!isRecentTransactionsCountRequestInProgress; else skeletonLoader"
						>
							<span *ngIf="!recentTransactionsCount?.totalTransactions" class="fn-size-12">
								No recent matching transactions found
							</span>
							<span
								class="primary-text font-size-12 cursor-pointer text-underline"
								*ngIf="
									recentTransactionsCount?.totalTransactions &&
									recentTransactionsCount?.pastDays == 0
								"
								(click)="openRecentTransactionsDialog()"
								fxLayoutAlign="start center"
								#recentTransactionsLink
							>
								View {{ recentTransactionsCount?.totalTransactions }} Similar Transactions for the
								current day
							</span>
							<span
								class="primary-text font-size-12 cursor-pointer text-underline"
								*ngIf="
									recentTransactionsCount?.totalTransactions &&
									recentTransactionsCount?.pastDays != 0
								"
								(click)="openRecentTransactionsDialog()"
								fxLayoutAlign="start center"
								#recentTransactionsLink
							>
								View {{ recentTransactionsCount?.totalTransactions }} Similar Transactions from the
								last {{ recentTransactionsCount?.pastDays }} days
							</span>
						</div>
					</div>
				</div>
			</div>
			<!-- With GreenScreens -->
			<div
				*ngIf="
					!priceNotFound &&
					isCitySelectedInSearchTruckForm &&
					greenScreensEnabled
				"
			>
				<div
					fxLayout="row"
					fxLayoutGap="1rem"
					*ngIf="showCurrentRatesCard; else currentRatesNotAvailable"
				>
					<div fxFlex fxLayout="column" fxLayoutAlign="center start">
						<div
							class="full-width"
							fxLayout="row"
							fxLayoutGap="1rem"
							[ngStyle]="{
								'min-height': allInPriceContainer?.nativeElement?.offsetWidth
									? 'calc(' + (allInPriceContainer.nativeElement.offsetHeight + 'px)')
									: 'inherit'
							}"
						>
							<div fxFlex>
								<div fxFlex fxLayoutAlign="start center" #perMileColumnContaier>
									<div class="full-width" fxLayoutAlign="start center">
										<div class="font-size-16 font-weight-bold" fxLayoutAlign="start center">
											Per Mile:
										</div>
										<div fxLayout="column" fxFlex fxLayoutAlign="center center">
											<div
												class="font-size-16 font-weight-bold"
												fxFlex
												*ngIf="!isLanePricingRequestInProgress; else skeletonLoader"
											>
												{{
													lanePricing?.allInCost && lanePricing?.laneMiles
														? (lanePricing.allInCost / lanePricing.laneMiles
														  | currency : 'USD' : 'symbol' : '1.2-2')
														: 'N/A'
												}}
											</div>
											<div
												fxFlex
												class="font-size-12"
												*ngIf="!isLanePricingRequestInProgress; else skeletonLoader"
											>
												({{
													lanePricing?.allInCostLow / lanePricing?.laneMiles
														? (lanePricing.allInCostLow / lanePricing.laneMiles
														  | currency : 'USD' : 'symbol' : '1.2-2')
														: 'N/A'
												}}
												-
												{{
													lanePricing?.allInCostHigh / lanePricing?.laneMiles
														? (lanePricing.allInCostHigh / lanePricing.laneMiles
														  | currency : 'USD' : 'symbol' : '1.2-2')
														: 'N/A'
												}})
											</div>
										</div>
									</div>
								</div>
								<div fxFlex>
									<div
										class="full-width p-l-1"
										fxLayout="column"
										fxFlex
										fxLayoutAlign="space-between start"
									>
										<div fxFlex fxLayoutAlign="start center">
											<span class="font-weight-bold">Fuel/Gal: &nbsp;&nbsp;&nbsp;</span>
											<span
												class="font-weight-normal"
												*ngIf="!isLanePricingRequestInProgress; else skeletonLoader"
											>
												{{
													lanePricing?.fuelCostPerMile
														? (lanePricing.fuelCostPerMile | currency : 'USD' : 'symbol' : '1.2-2')
														: 'N/A'
												}}
											</span>
										</div>
										<div fxFlex fxLayoutAlign="start center" #perMileEndContaier>
											<span class="font-weight-bold">Trip Miles:&nbsp;&nbsp;</span>
											<span
												class="font-weight-normal"
												*ngIf="!isLanePricingRequestInProgress; else skeletonLoader"
											>
												{{ lanePricing?.laneMiles ? lanePricing?.laneMiles : 'N/A' }}
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div
							fxLayout="row"
							fxLayoutGap="1rem"
							*ngIf="!isRecentTransactionsCountRequestInProgress; else skeletonLoader"
							class="m-t-0-5"
						>
							<div
								fxFlex
								fxLayoutAlign="start start"
								*ngIf="recentTransactionsCount?.totalTransactions"
							>
								<span
									class="primary-text font-size-12 cursor-pointer text-underline"
									*ngIf="recentTransactionsCount?.pastDays == 0"
									(click)="openRecentTransactionsDialog()"
									fxLayoutAlign="start center"
									#recentTransactionsLink
								>
									View {{ recentTransactionsCount?.totalTransactions }} Similar Transactions for the
									current day
								</span>
								<span
									class="primary-text font-size-12 cursor-pointer text-underline"
									*ngIf="recentTransactionsCount?.pastDays != 0"
									(click)="openRecentTransactionsDialog()"
									fxLayoutAlign="start center"
									#recentTransactionsLink
								>
									View {{ recentTransactionsCount?.totalTransactions }} Similar Transactions from
									the last {{ recentTransactionsCount?.pastDays }} days
								</span>
							</div>
						</div>
					</div>
					<div fxFlex>
						<div fxLayout="row" fxLayoutGap="1rem">
							<div fxFlex *ngIf="greenScreensEnabled" #allInPriceContainer>
								<div fxLayout="row" fxLayoutAlign="space-between center">
									<div fxFlex class="font-size-16 font-weight-bold" fxLayoutAlign="start center">
										All In:
									</div>
									<div fxLayout="column" fxFlex fxLayoutAlign="center center">
										<div
											fxFlex
											class="font-size-2rem font-weight-bold"
											*ngIf="!isLanePricingRequestInProgress; else skeletonLoader"
										>
											{{ lanePricing.allInCost | currency : 'USD' : 'symbol' : '1.0-0' }}
										</div>
										<div fxFlex *ngIf="!isLanePricingRequestInProgress; else skeletonLoader">
											({{ lanePricing?.allInCostLow | currency : 'USD' : 'symbol' : '1.0-0' }} -
											{{ lanePricing?.allInCostHigh | currency : 'USD' : 'symbol' : '1.0-0' }})
										</div>
									</div>
								</div>
							</div>
							<div fxFlex="40" fxLayoutAlign="start start">
								<div fxLayout="column" class="p-l-1" #allInPriceEnd>
									<div
										class="full-width confidence_meter_container"
										fxLayoutAlign="end start"
										*ngIf="lanePricing; else skeletonLoader"
									>
										<meter
											[style.width]="CONFIDENCE_METER_CONTAINER"
											high="4"
											low="2"
											max="5"
											min="0"
											optimum="5"
											[value]="lanePricing.confidenceScore"
										></meter>
									</div>
									<div
										class="full-width"
										fxLayoutAlign="end start"
										*ngIf="lanePricing; else skeletonLoader"
									>
										<span class="fn-size-13">Confidence:</span>
										<span>
											<mat-icon
												class="fn-size-13 confidence_meter_info_icon"
												fxLayoutAlign="center end"
												[mtxPopoverTriggerFor]="confidencePopover"
											>
												info_outline
											</mat-icon>
										</span>
									</div>
								</div>
							</div>
						</div>
						<div fxLayout="row" fxLayoutGap="1rem" class="m-t-0-5">
							<div fxFlex fxLayoutAlign="space-between start">
								<div
									[ngStyle]="{
										'min-width': allInPriceContainer?.nativeElement?.offsetWidth
											? 'calc(' + (allInPriceContainer.nativeElement.offsetWidth + 32 + 85) + 'px)'
											: 'inherit'
									}"
								>
									<div fxLayoutAlign="space-between center">
										<span fxLayoutAlign="start center"> Is the rate accurate? </span>
										<span *ngIf="lanePricing; else skeletonLoader">
											<mat-radio-button
												(click)="!rateFeedbackProvided && submitRateFeedback('spotOn')"
												class="font-size-12"
												color="primary"
											>
												Spot On
											</mat-radio-button>
										</span>
										<span *ngIf="lanePricing; else skeletonLoader">
											<mat-radio-button
												(click)="!rateFeedbackProvided && submitRateFeedback('notAccurate', 'high')"
												class="font-size-12"
												color="primary"
											>
												High
											</mat-radio-button>
										</span>
										<span *ngIf="lanePricing; else skeletonLoader">
											<mat-radio-button
												(click)="!rateFeedbackProvided && submitRateFeedback('notAccurate', 'low')"
												class="font-size-12"
												color="primary"
											>
												Low
											</mat-radio-button>
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div fxFlex fxLayoutAlign="end center" fxLayoutGap="1.5rem">
						<div>
							<div fxLayout="column" style="max-width: 180px">
								<div fxLayoutAlign="end end">
									<img
										alt="GreenScreens"
										class="greenScreensLogo"
										src="./assets/images/greenscreens.png"
									/>
								</div>
								<div fxLayoutAlign="end end" style="padding-top: 7px">Target Buy Rate</div>
							</div>
						</div>
						<div>
							<div fxLayout="column">
								<div
									*ngIf="!isGreenScreenRequestInProgress; else skeletonLoader"
									class="font-size-2rem"
									fxLayoutAlign="end end"
								>
									<strong *ngIf="greenScreenRate?.targetBuyRate; else loadingText">
										{{ greenScreenRate.targetBuyRate | currency : 'USD' : 'symbol' : '1.0-0' }}
									</strong>
								</div>

								<div
									*ngIf="!isGreenScreenRequestInProgress; else skeletonLoader"
									fxLayoutAlign="end end"
								>
									Start:
									{{
										greenScreenRate?.startBuyRate
											? (greenScreenRate.startBuyRate | currency : 'USD' : 'symbol' : '1.0-0')
											: 'N/A'
									}}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<ng-container
				*ngIf="priceNotFound || !isCitySelectedInSearchTruckForm"
				[ngTemplateOutlet]="currentRatesErrorMsgV2Layout"
			></ng-container>
		</mat-card-content>
	</mat-card>
</div>

<mtx-popover #recentTransactionsPopover="mtxPopover" [closeOnPanelClick]="false">
	<mat-card class="p-0 primary-border">
		<mat-card-content class="users-dropdown font-size-14">
			<div class="padding-0-5 primary-text">
				<p>
					Recent Transactions are selected based on the search criteria and the deadhead filters you
					have set.
				</p>
				<p>Transaction in italics are transactions captured for your account.</p>
			</div>
		</mat-card-content>
	</mat-card>
</mtx-popover>

<ng-template #loadingText>
	<span>...</span>
</ng-template>

<ng-template #currentRatesErrorMsg>
	<div class="recentTransactionsLoader primary-text" fxLayoutAlign="center center">
		<span *ngIf="priceNotFound && isCitySelectedInSearchTruckForm">
			No Result found
		</span>
		<span *ngIf="!isCitySelectedInSearchTruckForm" class="p-2 text-center">
			Current Rates are only available when the origin, destination, and equipment are provided.
		</span>
	</div>
</ng-template>

<ng-template #recentTransactionsLoader>
	<div class="recentTransactionsLoader primary-text" fxLayoutAlign="center center">
		<span *ngIf="showRecentTransactionsCard">Loading...</span>
		<span
			*ngIf="!showRecentTransactionsCard && isCitySelectedInSearchTruckForm"
		>
			No Result found
		</span>
		<span
			*ngIf="!showRecentTransactionsCard && !isCitySelectedInSearchTruckForm"
			class="p-2 text-center"
		>
			Recent Transactions are only available when the origin, destination, and equipment are provided.
		</span>
	</div>
</ng-template>

<ng-template #recentTransactionsSkeleton>
	<div *ngIf="productsService.RECENT_TRANSACTIONS" class="h-100">
		<app-skeleton-loader [SHOW_RECENT_TRANSACTIONS]="true"></app-skeleton-loader>
	</div>
</ng-template>

<ng-template #skeletonLoader>
	<div fxFlex fxLayoutAlign="end center">
		<app-skeleton-loader
			[SHOW_SINGLE_LOADER]="true"
			class="skeletonLoaderWidth"
		></app-skeleton-loader>
	</div>
</ng-template>

<ng-template #currentRatesErrorMsgV2Layout>
	<div class="primary-text" fxLayoutAlign="center center">
		<span *ngIf="priceNotFound && isCitySelectedInSearchTruckForm">
			No Result found
		</span>
		<span *ngIf="!isCitySelectedInSearchTruckForm" class="text-center">
			Current Rates are only available for city to city searches
		</span>
	</div>
</ng-template>

<ng-template #currentRatesNotAvailable>
	<div class="primary-text" fxLayoutAlign="center center">No Result found</div>
</ng-template>

<mtx-popover #confidencePopover="mtxPopover" [closeOnPanelClick]="false">
	<mat-card class="p-0 primary-border">
		<mat-card-content class="confidence_popover_container font-size-14">
			<div class="padding-0-5 primary-text">
				<p class="text_align_justify">
					C4 pricing is generated by a set of predictive models calculated on millions of rows of
					transaction data. Those models are then applied to your data, as well as, matching recent
					transactions, and the search criteria enetered to produce a predicted market rate.
				</p>
				<p class="text_align_justify">
					The confidence score measures how confident the pricing system is in its prediction.
					Confidence is based on which pricing model is used, how many recent transactions are
					available, and how much historical data you have for the lane.
				</p>
			</div>
		</mat-card-content>
	</mat-card>
</mtx-popover>
